/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nothing_More_To_LoadInputs */



/**
* | output |
* | --- |
* | "Nothing more to load" |
*
* @param {Nothing_More_To_LoadInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const nothing_more_to_load = /** @type {((inputs?: Nothing_More_To_LoadInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nothing_More_To_LoadInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Nothing more to load")
	return /** @type {LocalizedString} */ ("Rien de plus à charger")
});